export default "__VITE_ASSET__w$_1lgC7__"